/**
 * Periodic scheduler for background data collection tasks.
 * Mirrors Android PeriodicDataScheduler.
 */
export class PeriodicDataScheduler {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(
    private readonly task: () => void,
    private readonly intervalMs = 5_000,
  ) {}

  start(): void {
    if (this.intervalId !== null) return;
    this.intervalId = setInterval(() => {
      try {
        this.task();
      } catch {
        // Swallow errors — scheduler must not crash
      }
    }, this.intervalMs);
  }

  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  isRunning(): boolean {
    return this.intervalId !== null;
  }
}
